function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs162"
}, /*#__PURE__*/React.createElement("style", {
  id: "style160"
}, "{\".cls-2{fill:#003168}\"}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "path166",
  transform: "translate(-16.17 -8.85)",
  d: "M58.94 8.85H20.73a4.48 4.48 0 00-4.56 4.39v26.33A4.48 4.48 0 0020.73 44h38.21a4.49 4.49 0 004.56-4.39V13.24a4.49 4.49 0 00-4.56-4.39z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path168",
  className: "cls-2",
  transform: "translate(-16.17 -8.85)",
  d: "M46.59 14.06H34.31a1 1 0 00-1 1v22.66a1 1 0 001 1h11.58c11.5 0 12.42-9 12.42-11.52v-1.9c-.4-9.89-8.46-11.24-11.72-11.24zM44.76 32h-3.64V20.85h3.77s5.32-.4 5.32 5.43A5.35 5.35 0 0144.76 32z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path170",
  transform: "translate(-16.17 -8.85)",
  d: "M30.46 19.81v-4.74a1 1 0 00-1-1h-5.8a1 1 0 00-1 1v7.87z",
  fill: "#f04e23"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path172",
  className: "cls-2",
  transform: "translate(-16.17 -8.85)",
  d: "M22.64 25.8v11.92a1 1 0 001 1h5.8a1 1 0 001-1v-15z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path174",
  className: "cls-2",
  transform: "translate(-16.17 -8.85)",
  d: "M58.94 10.15a3.18 3.18 0 013.25 3.09v26.33a3.18 3.18 0 01-3.25 3.09H20.73a3.18 3.18 0 01-3.26-3.09V13.24a3.18 3.18 0 013.26-3.09h38.21m0-1.3H20.73a4.48 4.48 0 00-4.56 4.39v26.33A4.48 4.48 0 0020.73 44h38.21a4.49 4.49 0 004.56-4.39V13.24a4.49 4.49 0 00-4.56-4.39z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "text186",
  transform: "translate(53.17 29.86)",
  fill: "#003168",
  "aria-label": "KAART",
  fontSize: "33.54px",
  fontFamily: "Aino-Bold,Aino",
  fontWeight: "{700} "
}, /*#__PURE__*/React.createElement("path", {
  id: "path193",
  d: "M7.446 0v-12.779L18.246 0h5.232v-.805L12.913-13.047l10.464-11.001v-.771H18.38L7.446-12.946V-24.82H2.683V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path195",
  d: "M24.485-.872V0h4.628l2.617-6.91h10.263L44.709 0h4.73v-.872L40.013-24.82h-6.038zm11.806-17.944l.436-1.375h.168l.436 1.375 3.22 8.25h-7.413z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path197",
  d: "M50.361-.872V0h4.628l2.617-6.91h10.263L70.585 0h4.73v-.872L65.89-24.82h-6.037zm11.806-17.944l.436-1.375h.168l.436 1.375 3.22 8.25h-7.413z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path199",
  d: "M82.321 0v-9.727h2.314c2.583 0 4.025 1.241 5.065 3.59L92.383 0h4.73v-.906l-2.516-6.037c-.839-1.912-1.946-3.287-3.354-3.79 2.918-.771 5.467-3.052 5.467-6.842 0-3.958-3.187-7.245-8.15-7.245H77.557V0zm4.83-20.963c2.884 0 4.427 1.61 4.427 3.79 0 2.28-1.777 3.69-4.327 3.69h-4.93v-7.48z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path201",
  d: "M111.76 0v-20.828h8.72v-3.991H98.277v3.991h8.72V0z"
}));

var SvgIdKaart = function SvgIdKaart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 179.27 38.21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdKaart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/id_kaart.21eb2fb8.svg";
export { ForwardRef as ReactComponent };